module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.unconfirmedOrders.length > 0 && _vm.$router.name != 'waiting-for-delivery-view') ? _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Uzmanību!\n        ")]), _vm._v(" "), _c('p', [_vm._v("Lūdzu apstipriniet rītdienas BIOveikala Autoship pasūtījumu "), _c('b', [_vm._v("#" + _vm._s(_vm.unconfirmedOrders[0].id))]), _vm._v(" uz adresi "), _c('b', [_vm._v(_vm._s(_vm.unconfirmedOrders[0].address))])]), _vm._v(" "), _c('div', {
    staticClass: "ui custom_brown button",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "visible content",
    on: {
      "click": function($event) {
        return _vm.confirmOrderDelivery(_vm.unconfirmedOrders[0])
      }
    }
  }, [_vm._v("Apstiprināt rītdienas piegādi")])])])]) : _vm._e(), _vm._v(" "), (_vm.order.confirmed && _vm.order.status >= 3) ? _c('div', {
    staticClass: "ui positive icon message"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Paldies!\n        ")]), _vm._v(" "), _c('p', [_vm._v("BIOveikala Autoship pasūtījums tiks piegādāts "), _c('b', [_vm._v(_vm._s(_vm.order.delivery_date))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fb95cae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = 334
// module chunks = 1